import { AppContext } from '@lightspeed-invoicing/core-client/frontend/index'
import React, { Component } from 'react'
import DebounceInput from 'react-debounce-input'
import { FormattedMessage } from 'react-intl'
import FormattedInputField from '../../sharedComponents/formattedInputField.component.jsx'
import { UNIT_OF_MEASURE } from "../../state/product/Types"
import GlobalHelper from '../GlobalHelper.jsx'
import InputHoursMinutes from "./inputhoursminutes.component.jsx"

class InputUnitOfMeasure extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            id: this.props.id || '',
            measure: this.props.value || '',
            unit: this.props.unit || UNIT_OF_MEASURE.PIECE,
            name: this.props.name || 'name',
            step: this.props.unit === UNIT_OF_MEASURE.PIECE ? '1' : '0.1',
            className: this.props.className || '',
            groupClassName: this.props.groupClassName || '',
            style: this.props.style || {},
            format: this.props.format || 'normal',
            disabled: this.props.disabled === true,
            debounced: this.props.debounced === true,
            verticalAlignment: this.props.verticalAlignment || false,
            hour: '0',
            minute: '0',
            allowNegative: !this.props.allowNegative ? this.props.allowNegative : true,
        }

        const defaultCallback = () => {
        }
        this.onDebounceChange = this.onDebounceChange.bind(this)
        this.onChange = this.props.onChange || defaultCallback
        this.handleFocus = this.handleFocus.bind(this)
    }

    handleFocus(event) {
        event.target.select()
    }

    componentWillReceiveProps ( nextProps ) {
        this.setState({
            measure: nextProps.value || '',
            unit: nextProps.unit || UNIT_OF_MEASURE.PIECE,
            step: nextProps.unit === UNIT_OF_MEASURE.PIECE ? '1' : '0.1',
            disabled: nextProps.disabled === true,
        })
    }

    renderUnit() {
        const format = !this.state.verticalAlignment ? this.state.format : ''
        switch (this.state.unit) {
            case UNIT_OF_MEASURE.PIECE:
                if (format === 'short') {
                    return 'x'
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.piece_label"
                    defaultMessage="units"
                />
            case UNIT_OF_MEASURE.MONTH:
                if (format === 'short') {
                    return 'mo'
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.month_label"
                    defaultMessage="months"
                />
            case UNIT_OF_MEASURE.YEAR:
                if (format === 'short') {
                    return 'ys'
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.year_label"
                    defaultMessage="years"
                />
            case UNIT_OF_MEASURE.TRAVEL:
                if (format === 'short') {
                    return 't'
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.travel_label"
                    defaultMessage="Travels"
                />
            case UNIT_OF_MEASURE.PARTICIPANT:
                if (format === 'short') {
                    return 'ps'
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.participant_label"
                    defaultMessage="participants"
                />
            case UNIT_OF_MEASURE.USER:
                if (format === 'short') {
                    return 'us'
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.user_label"
                    defaultMessage="users"
                />
            case UNIT_OF_MEASURE.PAGE:
                if (format === 'short') {
                    return 'p'
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.page_label"
                    defaultMessage="pages"
                />
            case UNIT_OF_MEASURE.PERSON:
                if (format === 'short') {
                    return 'pers'
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.person_label"
                    defaultMessage="persons"
                />
            case UNIT_OF_MEASURE.INCH:
                return '"'
            case UNIT_OF_MEASURE.FOOT:
                return "'"
            case UNIT_OF_MEASURE.YARD:
                return <FormattedMessage
                    id="common.unit_of_measure.input.input_yard_label"
                    defaultMessage="yd"
                />
            case UNIT_OF_MEASURE.QUARTER:
                return <FormattedMessage
                    id="common.unit_of_measure.input.input_quarter_label"
                    defaultMessage="qtr"
                />
            case UNIT_OF_MEASURE.MILE:
                return "mi"
            case UNIT_OF_MEASURE.CENTIMETER:
                return "cm"
            case UNIT_OF_MEASURE.METER:
                return "m"
            case UNIT_OF_MEASURE.KILOMETER:
                return "km"
            case UNIT_OF_MEASURE.SQUARE_METER:
                return "m²"
            case UNIT_OF_MEASURE.CUBIC_METER:
                return "m3"
            case UNIT_OF_MEASURE.LITER:
                return "l"
            case UNIT_OF_MEASURE.MILLILITER:
                return "ml"
            case UNIT_OF_MEASURE.GRAM:
                return "g"
            case UNIT_OF_MEASURE.KILOGRAM:
                return "kg"
            case UNIT_OF_MEASURE.TON:
                return "t"
            case UNIT_OF_MEASURE.OUNCE:
                return "oz"
            case UNIT_OF_MEASURE.GALLON:
                return "gal"
            case UNIT_OF_MEASURE.POUND:
                return "lb"
            case UNIT_OF_MEASURE.HOUR:
                return "h"
            case UNIT_OF_MEASURE.MINUTE:
                return "min"
            case UNIT_OF_MEASURE.DAY:
                if(format == "large"){
                    return <FormattedMessage
                    id="common.unit_of_measure.input.input_large_day_label"
                    defaultMessage="day(s)"
                />
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.input_day_label"
                    defaultMessage="d"
                />
            case UNIT_OF_MEASURE.GIGABYTE:
                return <FormattedMessage
                    id="common.unit_of_measure.input.input_gigabyte_label"
                    defaultMessage="GB"
                />
            case UNIT_OF_MEASURE.MEGABYTE:
                return <FormattedMessage
                    id="common.unit_of_measure.input.input_megabyte_label"
                    defaultMessage="MB"
                />
            case UNIT_OF_MEASURE.ASSET:
                return <FormattedMessage
                    id="common.unit_of_measure.input.input_asset_label"
                    defaultMessage="assets"
                />
            case UNIT_OF_MEASURE.EPISODE:
                return <FormattedMessage
                    id="common.unit_of_measure.input.episode_label"
                    defaultMessage="episodes"
                />
            case UNIT_OF_MEASURE.TALENT:
                return <FormattedMessage
                    id="common.unit_of_measure.input.talent_label"
                    defaultMessage="talents"
                />
            case UNIT_OF_MEASURE.SQUARE_FOOT:
                return <FormattedMessage
                    id="common.unit_of_measure.input.square_foot_label"
                    defaultMessage="ft²"
                />
            case UNIT_OF_MEASURE.SERVING:
                if (format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.serving_label_shortcut"
                        defaultMessage="srv"
                    />
                }
                return <FormattedMessage
                    id="common.unit_of_measure.input.serving_label"
                    defaultMessage="servings"
                />
        }
    }

    renderPlaceHolder() {
        switch (this.state.unit) {
            case UNIT_OF_MEASURE.PIECE:
            case UNIT_OF_MEASURE.HOUR:
            case UNIT_OF_MEASURE.DAY:
            case UNIT_OF_MEASURE.MINUTE:
            case UNIT_OF_MEASURE.MONTH:
            case UNIT_OF_MEASURE.YEAR:
            case UNIT_OF_MEASURE.PARTICIPANT:
            case UNIT_OF_MEASURE.USER:
                return "0"
            default:
                return "0.00"
        }
    }

    onDebounceChange(event) {
        if (!event.target) {
            return
        }
        this.setState({
            measure: event.target.value
        }, () => {
            this.onChange(event.target.value)
        })
    }


    render() {
        let className = this.state.className
        const ignoreVerticalAlignment = !this.state.verticalAlignment
        className = ignoreVerticalAlignment ? className : className + ' w-100 rounded-0 h-25 text-center'

        switch (this.state.unit) {
            case UNIT_OF_MEASURE.HOURS_MINUTE:
                return <InputHoursMinutes
                    id={this.state.id}
                    value={this.state.measure}
                    className={className}
                    groupClassName={this.state.groupClassName}
                    style={this.state.style}
                    format={this.state.format}
                    disabled={this.state.disabled}
                    verticalAlignment={ignoreVerticalAlignment}
                    onChange={this.onChange}
                />
            default:
                return <div className={"input-group " + this.state.groupClassName} style={this.state.style}>
                    {this.state.debounced ? <DebounceInput
                        disabled={this.state.disabled}
                        name={this.state.name}
                        id={this.state.id || this.state.name}
                        type="number"
                        display="none"
                        className={"form-control " + className}
                        placeholder={GlobalHelper.applyLocaleDecimal(this.renderPlaceHolder(), AppContext.getLocale().getLanguage())}
                        value={this.state.measure}
                        onChange={this.onDebounceChange}
                        min={0}
                        minLength={0}
                        debounceTimeout={300}
                        autoComplete="off"
                        onFocus={this.handleFocus}
                        onClick={this.handleFocus}
                    /> :
                        <FormattedInputField
                            disabled={this.state.disabled}
                            name={this.state.name}
                            id={this.state.id || this.state.name}
                            type="text"
                            className={"form-control " + className}
                            placeholder={GlobalHelper.applyLocaleDecimal(this.renderPlaceHolder(), AppContext.getLocale().getLanguage())}
                            valueType="decimal"
                            autoComplete="off"
                            value={this.state.measure}
                            onValueChange={(newValue) => {
                                this.setState({
                                    measure: newValue
                                }, () => {
                                    this.onChange(newValue)
                                })
                            }}
                            onFocus={this.handleFocus}
                            onClick={this.handleFocus}
                            allowNegative={this.state.allowNegative}
                        />}

                    <div className={ignoreVerticalAlignment ? 'input-group-append ' : 'w-100 ml-0 bg-light d-flex align-items-center text-center'}>
                        {ignoreVerticalAlignment ? 
                            <span className={"input-group-text " + (this.state.format === 'short' ? 'px-2' : '')} id="basic-addon2" >
                                {this.renderUnit()}
                            </span> :
                            <small className={'w-100 rounded-0'} id="basic-addon2" >
                                {this.renderUnit()}
                            </small>
                        }
                    </div>
                </div>

        }
    }
}

export default InputUnitOfMeasure





// WEBPACK FOOTER //
// ./src/common/unit-of-measure/input.component.jsx